'use client'

import { IconAlertCircleYellow } from '@macarongfactory/web-icons'
import { Result, SolidButton } from '@macarongfactory/web-ui'

/** 에러 아이콘 크기(px) — Figma 64×64 */
const ERROR_ICON_SIZE_PX = 64

const ERROR_TITLE = '화면을 불러오지 못했어요'
const ERROR_DESCRIPTION = '잠시 후 다시 시도해주세요'
const RETRY_BUTTON_TEXT = '다시 시도하기'

interface IRankErrorProps {
  /** 다시 시도 (기본: 새로고침) */
  onRetry?: () => void
}

/**
 * 랭킹 화면 로드 실패 — Figma 8455:72663
 */
const RankError = ({ onRetry }: IRankErrorProps) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry()
      return
    }
    window.location.reload()
  }

  return (
    <div className='flex min-h-dvh w-full flex-col items-center justify-center'>
      <Result
        top={
          <Result.Top.Image>
            <IconAlertCircleYellow
              width={ERROR_ICON_SIZE_PX}
              height={ERROR_ICON_SIZE_PX}
            />
          </Result.Top.Image>
        }
        title={<Result.Title text={ERROR_TITLE} />}
        description={<Result.Description text={ERROR_DESCRIPTION} />}
        button={
          <SolidButton
            variant='neutral-weak'
            text={RETRY_BUTTON_TEXT}
            size='medium'
            clickable={handleRetry}
          />
        }
      />
    </div>
  )
}

export default RankError
